// Event dates come back as naive UTC strings, so trim rather than parse.
export const utc = (value) => (value ? value.replace("T", " ").slice(0, 16) : "-");
